import styled from 'styled-components';

import {
  MethodContainer as BaseMethodContainer,
  MethodTypeWrapper as BaseMethodTypeWrapper,
  PrepaidMethodType as BasePrepaidMethodType,
} from './styled.base';

export * from './styled.base';

export const PrepaidMethodType = styled(BasePrepaidMethodType)`
  color: ${Styles.color.black};
`;

export const MethodContainer = styled(BaseMethodContainer)`
  color: ${Styles.color.black};
`;

export const MethodTypeWrapper = styled(BaseMethodTypeWrapper)`
  color: ${Styles.color.black};
`;
